/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OAuthBindEmailCodeReqVo
 */
export interface OAuthBindEmailCodeReqVo {
    /**
     * 绑定凭证
     * OAuth绑定凭证
     * @type {string}
     * @memberof OAuthBindEmailCodeReqVo
     */
    oauthBindToken: string;
    /**
     * 已注册会员邮箱
     * 已注册会员邮箱
     * @type {string}
     * @memberof OAuthBindEmailCodeReqVo
     */
    email: string;
}

/**
 * Check if a given object implements the OAuthBindEmailCodeReqVo interface.
 */
export function instanceOfOAuthBindEmailCodeReqVo(value: object): value is OAuthBindEmailCodeReqVo {
    if (!('oauthBindToken' in value) || value['oauthBindToken'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function OAuthBindEmailCodeReqVoFromJSON(json: any): OAuthBindEmailCodeReqVo {
    return OAuthBindEmailCodeReqVoFromJSONTyped(json, false);
}

export function OAuthBindEmailCodeReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OAuthBindEmailCodeReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'oauthBindToken': json['oauthBindToken'],
        'email': json['email'],
    };
}

export function OAuthBindEmailCodeReqVoToJSON(json: any): OAuthBindEmailCodeReqVo {
    return OAuthBindEmailCodeReqVoToJSONTyped(json, false);
}

export function OAuthBindEmailCodeReqVoToJSONTyped(value?: OAuthBindEmailCodeReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'oauthBindToken': value['oauthBindToken'],
        'email': value['email'],
    };
}

